import * as React from 'react';
import {Dropdown, DropdownMenuItemType, ResponsiveMode, SearchBox} from "@fluentui/react";
import {whitespaceMatcher} from "../Utilities/WhitespaceMatcher";

const SearchableDropdown = (props) => {
    const [searchText, setSearchText] = React.useState('');

    function renderOption(option) {
        return (option.itemType === DropdownMenuItemType.Header && option.key === "FilterHeader") ?
            <SearchBox onChange={(ev, newValue) => setSearchText(newValue)} underlined={true} placeholder="Wyszukaj" /> : <>{option.text}</>;
    }

    return (
        <Dropdown
            {...props}
            options={[
                { key: 'FilterHeader', text: '-', itemType: DropdownMenuItemType.Header },
                { key: 'divider_filterHeader', text: '-', itemType: DropdownMenuItemType.Divider },
                ...props.options.map(option => !option.disabled && whitespaceMatcher(searchText, option) ?
                    option : { ...option, hidden: true }
                ),
            ]}
            responsiveMode={ResponsiveMode.small}
            onRenderOption={renderOption}
            onDismiss={() => setSearchText('')}
        />
    );

};

export default SearchableDropdown;